module.exports = __webpack_public_path__ + "static/media/linkedIn.5059bcd8.svg";